var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMapIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 6.63999L8.92999 2.99999L1.98999 6.66999V20.99L8.88999 17.34L15.06 21L22 17.33V2.98999L15.1 6.63999ZM9.66999 5.16999L14.34 7.91999V18.83L9.66999 16.06V5.16999ZM3.49999 7.57999L8.16999 5.10999V16.04L3.49999 18.51V7.57999ZM20.5 16.43L15.83 18.9V7.94999L20.5 5.47999V16.44V16.43Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMapIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Map_Icon.f3bf237e40281a07cf084325ff3d7199.svg";